import { render, staticRenderFns } from "./prod-form.vue?vue&type=template&id=e2fbe764&scoped=true"
import script from "./prod-form.vue?vue&type=script&lang=js"
export * from "./prod-form.vue?vue&type=script&lang=js"
import style0 from "./prod-form.vue?vue&type=style&index=0&id=e2fbe764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fbe764",
  null
  
)

export default component.exports